// employee-portal/src/auth.js
export function setEmployeeSession(token, employee) {
  localStorage.setItem('emp_token', token);
  localStorage.setItem('emp_info', JSON.stringify(employee));
}

export function clearEmployeeSession() {
  localStorage.removeItem('emp_token');
  localStorage.removeItem('emp_info');
}

export function getEmployee() {
  const txt = localStorage.getItem('emp_info');
  if (!txt) return null;
  try {
    return JSON.parse(txt);
  } catch {
    return null;
  }
}

export function isLoggedIn() {
  return !!localStorage.getItem('emp_token');
}
